export default __webpack_public_path__ + "static/media/masthead.7c50d8f4.png";